import { create } from "zustand";
import { createInitialSessionOrchestratorState } from "./state";
import { sessionActionCreators, sessionOrchestratorReducer } from "./reducer";

const buildState = (initialState) => ({
  ...createInitialSessionOrchestratorState(initialState),
});

const reduceState = (state, action) => ({
  ...sessionOrchestratorReducer(state, action),
});

const useSessionOrchestratorStore = create((set) => ({
  ...buildState(),
  dispatch: (action) => set((state) => reduceState(state, action)),
  resetSessionOrchestrator: (initialState) => set(() => buildState(initialState)),
  startLogin: (returnTo) =>
    set((state) => reduceState(state, sessionActionCreators.loginStarted({ returnTo }))),
  startCallback: (returnTo) =>
    set((state) => reduceState(state, sessionActionCreators.callbackStarted({ returnTo }))),
  setTokensReady: (targetPath) =>
    set((state) =>
      reduceState(state, sessionActionCreators.callbackTokensReady({ targetPath }))
    ),
  startProfileBootstrap: (targetPath) =>
    set((state) =>
      reduceState(state, sessionActionCreators.profileBootstrapStarted({ targetPath }))
    ),
  resolveProfileBootstrap: ({ targetPath, requiresVerification = false } = {}) =>
    set((state) =>
      reduceState(
        state,
        sessionActionCreators.profileBootstrapResolved({
          targetPath,
          requiresVerification,
        })
      )
    ),
  requireVerification: (targetPath) =>
    set((state) =>
      reduceState(state, sessionActionCreators.verificationRequired({ targetPath }))
    ),
  requestRecovery: ({ blockingReason, targetPath, recoveryContext = null } = {}) =>
    set((state) =>
      reduceState(
        state,
        sessionActionCreators.recoveryRequested({
          blockingReason,
          targetPath,
          recoveryContext,
        })
      )
    ),
  retryBootstrap: (targetPath) =>
    set((state) =>
      reduceState(state, sessionActionCreators.bootstrapRetried({ targetPath }))
    ),
  failHard: ({ blockingReason, errorCode = "", targetPath } = {}) =>
    set((state) =>
      reduceState(
        state,
        sessionActionCreators.hardErrorRaised({
          blockingReason,
          errorCode,
          targetPath,
        })
      )
    ),
  acknowledgeError: () =>
    set((state) => reduceState(state, sessionActionCreators.errorAcknowledged())),
}));

export const resetSessionOrchestratorState = (initialState) =>
  useSessionOrchestratorStore.getState().resetSessionOrchestrator(initialState);

export default useSessionOrchestratorStore;
